// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 934 ? "category-card" : chunkId) + "." + {"183":"717e6f67","220":"a4c7ecf3","239":"12e1c763","267":"c1147fbf","408":"669013ac","453":"7df43028","455":"387fba76","740":"4e43d69a","762":"662a6c20","934":"3ecd3fb1","977":"b62ce402"}[chunkId] + ".chunk.js";
};